module.exports = __webpack_public_path__ + "fa-light-300.bd2b394b0ece2133a059b46f87617b1b.ttf";